<div
  class="rename-header-wrapper"
  [class.disabled]="isDisabled()"
  [class.mobile]="isMobile()"
>
  @if (!isInEditingMode()) {
    @if (location()?.curLayer === "d") {
      <span class="objecttype-label detail">
        {{
          i18n.langString(
            location()?.IsBuilding
              ? "asset_layer_label_d_building"
              : "asset_layer_label_d_area"
          )
        }}
      </span>
    } @else {
      <span class="objecttype-label detail">
        {{ i18n.langString("asset_layer_label_" + location()?.curLayer) }}
      </span>
    }

    @if (!innerWrapper() && !sidebar()) {
      <h2 [class.spaceright]="!isMobile() && !isEditable()">
        {{ location()?.objectName }}
      </h2>
    }

    @if (!innerWrapper() && sidebar()) {
      <span class="body-bold" style="display: block; margin-bottom: 8px">
        {{ objectNameLabel() }}
      </span>
    }

    @if (innerWrapper()) {
      <span
        [class.body-bold]="!sidebar()"
        [class.detail-bold]="sidebar()"
        style="display: block; word-break: break-word"
      >
        {{ objectNameLabel() }}
      </span>
    }
  }
</div>

<div [class.desktop-header-wrapper]="!isMobile()">
  @if (isInEditingMode()) {
    <app-validation-input
      [name]="editedName()"
      [siblings]="getSiblings()"
      [placeholder]="
        getRenamePlaceholder(i18n.langString('rename_placeholder'))
      "
      [label]="getRenameLabel()"
      [warnNameDuplicate]="false"
      [wideInput]="true"
      (nameChange)="onNameChange($event)"
      (nameErrorChange)="onNameErrorChange($event)"
      (nameDuplicateChange)="onNameDuplicate($event)"
    >
    </app-validation-input>

    <div
      class="button-wrapper"
      [class.oneButton]="location()?.curLayer === 'd'"
      [class.mobile-button-wrapper]="isMobile()"
    >
      @if (location()?.curLayer !== "d") {
        <app-nav-button
          [svgIcon]="'icons:delete'"
          [blackBorder]="true"
          (clickEvent)="onDeletePopup(location()!)"
          [lighttertiary]="true"
        >
          {{ i18n.langString("delete") }}
        </app-nav-button>
      }
      <app-nav-button
        [disabled]="nameErrorFlag() || nameDuplicate() || !editedName()"
        [svgIcon]="'icons:save'"
        [blackBorder]="true"
        (clickEvent)="onStopEdit()"
        [lighttertiary]="true"
      >
        {{ i18n.langString("save") }}
      </app-nav-button>
    </div>
  }
</div>

<div [class.mobile]="isMobile()">
  @if (isEditable()) {
    @if (!isInEditingMode()) {
      <i
        nz-icon
        nzType="edit"
        (click)="$event.stopPropagation(); onStartEdit()"
        (keypress)="$event.stopPropagation(); onStartEdit()"
        tabindex="0"
        role="button"
        class="edit-icon"
        [class.outerWrapper]="!innerWrapper()"
        [class.fillsilverchalice]="isDisabled()"
      >
      </i>
    }

    @if (
      innerWrapper() &&
      (location()?.children?.length === 0 || location()?.NextLayerIsEquipment)
    ) {
      <div
        class="collapse-card-last-eq-line"
        [class.longerLine]="isInEditingMode()"
        [class.muchLongerLine]="isInEditingMode() && nameErrorFlag()"
      ></div>
    }
  }
</div>

<!-- Delete Popup -->
@if (overlayDeletePopup()) {
  <app-delete-popup
    [objName]="overlayDeleteObject() ? overlayDeleteObject().objectName : ''"
    [objType]="typeOfDeleteObj(overlayDeleteObject())"
    (closeEvent)="onExit($event)"
  ></app-delete-popup>
}
